import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const InfoCircleIcon: React.FC<NormalIconProps> = (props) => (
	<svg id="INFO" xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 20 20">
		<path
			id="Path_5096"
			data-name="Path 5096"
			d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,18.182A8.182,8.182,0,1,1,18.182,10,8.191,8.191,0,0,1,10,18.182Z"
		/>
		<path
			id="Path_5097"
			data-name="Path 5097"
			d="M146.214,70a1.212,1.212,0,1,0,1.212,1.213A1.214,1.214,0,0,0,146.214,70Z"
			transform="translate(-136.214 -65.758)"
		/>
		<path
			id="Path_5098"
			data-name="Path 5098"
			d="M150.909,140a.909.909,0,0,0-.909.909v5.455a.909.909,0,0,0,1.818,0v-5.455A.909.909,0,0,0,150.909,140Z"
			transform="translate(-140.909 -131.515)"
		/>
	</svg>
);
